// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-build-1752467978110." + "dd4fcee45277ab17" + ".js";
};